module.exports = __webpack_public_path__ + "s/img/Chill_M_5.fd8b31b0.jpg";